import React, {useState, useEffect} from 'react';
import { IoClose as Close } from 'react-icons/io5';
import { FaRupeeSign as RupeeIcon } from "react-icons/fa";
import { IoIosCheckmark as RightIcon } from "react-icons/io";
import { MdInfo as InfoIcon } from "react-icons/md";
import { HiSparkles as SparklesIcon } from "react-icons/hi2";
import BuyProUserSeats from '@CommonViews/BuyProUserSeats';
import Modal from '@mui/material/Modal';
import Button from '@mui/material/Button';
import BorderBlueButtonV2 from '@CommonRepresentationalDisplay/Buttons/BorderBlueButtonV2';
import UserSeatService from '@Helpers/URLHelpers/BillingService/UserSeatService';
import ErrorHandler from '@Root/ErrorHandler';
import './MembersBuyView.scss';

export default function MembersBuyView(props) {

    const [pmUserSeatDetails, setPmUserSeatDetails] = useState(null);
    const [formAgentSeatDetails, setFormAgentSeatDetails] = useState(null);
    const KZQ_ENABLE_PRO_USER_SEAT = JSON.parse(localStorage.getItem('KZQ_ENABLE_PRO_USER_SEAT'));
    const userSeatService = new UserSeatService();
    const errorHandler = new ErrorHandler();
    const className = 'membersBuyView';

    useEffect(()=>{
        renderData();
    },[])

    const renderData = async ()=> {

    }

    const renderPmUserSeatDetails = async()=> {
        try {
            let getDetails = await userSeatService.getUserSeatDetails(props?.org?.id);
            getDetails = JSON.parse(getDetails.body);
            setPmUserSeatDetails(getDetails);
        } catch(err) {
            errorHandler.handleError(err);
        }
    }

    const renderFormAgentSeatDetails = async()=> {
        try {
            let getDetails = await userSeatService.getUserSeatDetailsByOrgIdAndSeatType(props?.org?.id, 'formAgent');
            getDetails = JSON.parse(getDetails.body);
            setFormAgentSeatDetails(getDetails);
        } catch(err) {
            errorHandler.handleError(err);
        }
    }

    const handleAddBasicUserSeat = ()=> {
        props.closePopup();
        props.toggleInviteUsersView();
    }

    const handleAddProUserSeat = ()=> {
        props.closePopup();
        props.toggleProUserSeat();
    }

    return (
        <Modal
            open={props.open}
            onClose={props.closePopup}
            aria-labelledby='modal-members-buy-view'>
                <div className={className}>
                    <div className={className + '__inner'}>
                        <div className={className + '__inner__titleBar'}>
                            <div className={className + '__inner__titleBar__title'}>
                                Invite Agents
                            </div>
                            <div 
                                className={className + '__inner__titleBar__close'}
                                onClick={props.closePopup}>
                                <Close />
                            </div>
                        </div>
                        
                        <div className={className + '__inner__body'}>
                            {/* Standard Seat */}
                            <div className={className + '__inner__body__left'}>
                                <div className={className + '__inner__body__left__header'}>
                                    <div className={className + '__inner__body__left__header__title'}>
                                        Add Agents to your Organization
                                    </div>
                                    <div className={className + '__inner__body__left__header__subtitle'}>
                                        Invite agents to collaborate on your projects with full access to essential features.
                                    </div>
                                </div>
                                
                                <div className={className + '__inner__body__left__features'}>
                                    <div className={className + '__inner__body__left__features__item'}>
                                        <div className={className + '__inner__body__left__features__item__icon'}>
                                            <RightIcon />
                                        </div>
                                        <div className={className + '__inner__body__left__features__item__text'}>
                                            Create, assign and update tasks with due dates and file attachments
                                        </div>
                                    </div>
                                    
                                    <div className={className + '__inner__body__left__features__item'}>
                                        <div className={className + '__inner__body__left__features__item__icon'}>
                                            <RightIcon />
                                        </div>
                                        <div className={className + '__inner__body__left__features__item__text'}>
                                            Receive email notifications and update statuses in real-time
                                        </div>
                                    </div>
                                    
                                    <div className={className + '__inner__body__left__features__item'}>
                                        <div className={className + '__inner__body__left__features__item__icon'}>
                                            <RightIcon />
                                        </div>
                                        <div className={className + '__inner__body__left__features__item__text'}>
                                            Comment on items and share photos and files with the team
                                        </div>
                                    </div>
                                    
                                    <div className={className + '__inner__body__left__features__item'}>
                                        <div className={className + '__inner__body__left__features__item__icon'}>
                                            <RightIcon />
                                        </div>
                                        <div className={className + '__inner__body__left__features__item__text'}>
                                            Be assigned to tickets and resolve them efficiently
                                        </div>
                                    </div>
                                    
                                    <div className={className + '__inner__body__left__features__item'}>
                                        <div className={className + '__inner__body__left__features__item__icon'}>
                                            <RightIcon />
                                        </div>
                                        <div className={className + '__inner__body__left__features__item__text'}>
                                            Share documents and files related to your projects
                                        </div>
                                    </div>
                                    
                                    <div className={className + '__inner__body__left__features__item'}>
                                        <div className={className + '__inner__body__left__features__item__icon'}>
                                            <RightIcon />
                                        </div>
                                        <div className={className + '__inner__body__left__features__item__text'}>
                                            Track progress and monitor worklog hours automatically
                                        </div>
                                    </div>
                                </div>
                                
                                <div className={className + '__inner__body__left__action'}>
                                    <Button
                                        variant="contained"
                                        size="large"
                                        fullWidth
                                        onClick={handleAddBasicUserSeat}
                                        sx={{
                                            textTransform: 'none',
                                            fontSize: '0.95rem',
                                            fontWeight: 500,
                                            padding: '0.75rem 2rem',
                                            borderRadius: '6px',
                                            boxShadow: 'none',
                                            '&:hover': {
                                                boxShadow: 'none',
                                            }
                                        }}>
                                        Invite Agents
                                    </Button>
                                </div>
                            </div>
                            
                            {/* Pro Seat */}
                            {KZQ_ENABLE_PRO_USER_SEAT && (
                                <div className={className + '__inner__body__right'}>
                                    <div className={className + '__inner__body__right__badge'}>
                                        Premium
                                    </div>
                                    
                                    <div className={className + '__inner__body__right__header'}>
                                        <div className={className + '__inner__body__right__header__title'}>
                                            <SparklesIcon />
                                            Pro Membership
                                        </div>
                                        <div className={className + '__inner__body__right__header__subtitle'}>
                                            Unlock advanced features
                                        </div>
                                    </div>
                                    
                                    <div className={className + '__inner__body__right__pricing'}>
                                        <div className={className + '__inner__body__right__pricing__currency'}>
                                            <RupeeIcon />
                                        </div>
                                        <div className={className + '__inner__body__right__pricing__amount'}>
                                            1200
                                        </div>
                                        <div className={className + '__inner__body__right__pricing__period'}>
                                            /month
                                        </div>
                                    </div>
                                    
                                    <div className={className + '__inner__body__right__features'}>
                                        <div className={className + '__inner__body__right__features__item'}>
                                            <div className={className + '__inner__body__right__features__item__icon'}>
                                                <RightIcon />
                                            </div>
                                            <div className={className + '__inner__body__right__features__item__text'}>
                                                All Standard features included
                                            </div>
                                        </div>
                                        
                                        <div className={className + '__inner__body__right__features__item'}>
                                            <div className={className + '__inner__body__right__features__item__icon'}>
                                                <RightIcon />
                                            </div>
                                            <div className={className + '__inner__body__right__features__item__text'}>
                                                WhatsApp integration & notifications
                                            </div>
                                        </div>
                                        
                                        <div className={className + '__inner__body__right__features__item'}>
                                            <div className={className + '__inner__body__right__features__item__icon'}>
                                                <RightIcon />
                                            </div>
                                            <div className={className + '__inner__body__right__features__item__text'}>
                                                Priority support
                                            </div>
                                        </div>
                                        
                                        <div className={className + '__inner__body__right__features__item'}>
                                            <div className={className + '__inner__body__right__features__item__icon'}>
                                                <RightIcon />
                                            </div>
                                            <div className={className + '__inner__body__right__features__item__text'}>
                                                Advanced analytics
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <div className={className + '__inner__body__right__action'}>
                                        <Button
                                            variant="outlined"
                                            size="large"
                                            fullWidth
                                            onClick={handleAddProUserSeat}
                                            sx={{
                                                textTransform: 'none',
                                                fontSize: '0.95rem',
                                                fontWeight: 500,
                                                padding: '0.75rem 2rem',
                                                borderRadius: '6px',
                                                borderColor: 'var(--color-primaryText)',
                                                color: 'var(--color-primaryText)',
                                                '&:hover': {
                                                    borderColor: 'var(--color-primaryText)',
                                                    backgroundColor: 'transparent',
                                                }
                                            }}>
                                            Try Pro
                                        </Button>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
        </Modal>
    )
}